// hours of operation
export const hoursOfOperation = { open: 7, close: 23 };
export const clientHoursOfOperation = { open: 9, close: 23 };
export const clientWeeklyServiceTimeOptions = [9, 10, 14, 15]

export const menuSelectionMaxQuantity = 6;

export const minimumLoadTime = 3000;
export const resetDelayTime = 800;
export const servicesPerPage = 8;
export const buttonAnimationInDuration = 133;
export const errorDisplayTime = 5000;

export const taxRate = 0.08875;

export const mailToQ = 'mailto:q@theculinistas.com';
export const ReheatPDF =
  'https://s3.amazonaws.com/culinistas-production/pdf/Best-Practices-Reheating.pdf';
export const BestPracticesPDF =
  'https://s3.amazonaws.com/culinistas-production/pdf/Client+Best+Practices+.pdf';

export const RTE_DEFAULT_TOOLBAR_CONFIG = {
  display: [
    'INLINE_STYLE_BUTTONS',
    'BLOCK_TYPE_BUTTONS',
    'LINK_BUTTONS',
    'HISTORY_BUTTONS'
  ],
  INLINE_STYLE_BUTTONS: [
    { label: 'Bold', style: 'BOLD' },
    { label: 'Italic', style: 'ITALIC' },
    { label: 'Strikethrough', style: 'STRIKETHROUGH' },
    { label: 'Code', style: 'CODE' },
    { label: 'Underline', style: 'UNDERLINE' }
  ],
  BLOCK_TYPE_BUTTONS: [
    { label: 'UL', style: 'unordered-list-item' },
    { label: 'OL', style: 'ordered-list-item' }
  ]
};

// mediaquery breakpoints
export const breakpoints = {
  iphone: 376,
  mobile: 426,
  tablet: 769,
  desktop: 1440
};

export const allStates = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'DC', label: 'District Of Columbia' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' }
];

// hosts
export const APP_HOST = process.env.REACT_APP_APP_HOST;
export const WWW_HOST = process.env.REACT_APP_WWW_HOST;
export const API_HOST = process.env.REACT_APP_API_HOST;

// export const PROTOCOL = process.env.REACT_APP_SCHEMA;
export const CHEF_PORTAL_HOST = process.env.REACT_APP_CHEF_PORTAL_HOST || 'culinistas-chef-portal.vercel.app'

// colors
export const navy = '#081736';
export const redBrick = '#B82C0F';
export const green = '#093C34';
export const darkTaupe = '#78726a';

// fonts
export const sansSerif = 'Helvetica-Neue';

// Grocery Fees Estimates Ranges
export const estimatedGroceryFees = {
  small: [120,160],
  medium: [160,200],
  large: [220,260]
};

// Service Changes
export const serviceCharges = {
  serviceFee: 250,
  tip: 50,
  travel: 15,
  tax: 22
}

// Estimated Totals
export const estimatedTotals = {
  small: 394.0,
  medium: 444.0,
  large: 454.0
};

export const chefVIPIndicator = '*';

export const startTipDate = Date.parse("2022-04-01T00:00:00.000-04:00");

export const defaultWeeklyTipCents = 5000;
export const defaultTravelCents = 1500;

export const CHEF_ROLES = {
  CHEF: 'Chef',
  SOUS_CHEF: 'Sous Chef',
  BARTENDER: 'Bartender',
  WAITER: 'Waiter',
}

export const TRAVEL_FEE = 1500

export const SERVICE_TYPES = {
  WEEKLY: 'weekly',
  OCCASION: 'occasion',
  CUSTOM_WEEKLY: 'custom_weekly',
  MARKETING_OCCASION: 'marketing_occasion',
  CUSTOM_OCCASION: 'custom_occasion',
  COOKING_CLASS: 'cooking_class'
}

export const ACCOUNT_STATUSES = {
  ACTIVE: 'account_active',
  DEACTIVATED: 'account_deactivated',
  INACTIVE: 'account_inactive'
}

export const OCCASION_STATUS_LABELS = {
  'inquiry' : 'Inquiry', 
  'wip': 'WIP',
  'planned': 'Planned',
  'client_cancelled': 'Client Cancelled' ,
  'chef_cancelled': 'Chef Cancelled' 
};

export const WEEKLY_STATUS_LABELS = {
  'planned' : 'Planned', 
  'client_cancelled': 'Client Cancelled' ,
  'chef_cancelled': 'Chef Cancelled' 
};


// WEBPACK FOOTER //
// ./src/const.js